import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Service worker registration removed
import { cleanupPWA } from './utils/cleanup-service-worker';

console.log("Application starting");

// Run cleanup early in app initialization, but conditionally
cleanupPWA().then((result) => {
  if (result.alreadyRan) {
    console.log('PWA cleanup already ran recently, skipping reload logic.');
  } else if (result.workersUnregistered || result.cachesCleared || result.localStorageCleared) {
    console.log('PWA resources cleaned up. Checking if reload is necessary...');
    
    // Only reload if we're on the gallery page and had significant cleanup
    if (window.location.pathname.includes('/gallery') && (result.workersUnregistered || result.cachesCleared)) {
      console.log('On gallery page with significant cleanup performed, refreshing for a clean start...');
      window.location.reload();
    }
  }
});

// Service worker registration removed to fix gallery caching issues

createRoot(document.getElementById("root")!).render(<App />);